"use client"

import * as React from "react"
import { Separator as SeparatorPrimitive } from "@base-ui/react/separator"

import { cn } from "@/lib/utils"

type SeparatorBleed = "1" | "2" | "3" | "4" | "6" | "8"

const HORIZONTAL_BLEED_CLASS: Record<SeparatorBleed, string> = {
  "1": "-mx-1",
  "2": "-mx-2",
  "3": "-mx-3",
  "4": "-mx-4",
  "6": "-mx-6",
  "8": "-mx-8",
}

const VERTICAL_BLEED_CLASS: Record<SeparatorBleed, string> = {
  "1": "-my-1",
  "2": "-my-2",
  "3": "-my-3",
  "4": "-my-4",
  "6": "-my-6",
  "8": "-my-8",
}

const HORIZONTAL_BLEED_SIZE_CLASS: Record<SeparatorBleed, string> = {
  "1": "w-[calc(100%+0.5rem)]",
  "2": "w-[calc(100%+1rem)]",
  "3": "w-[calc(100%+1.5rem)]",
  "4": "w-[calc(100%+2rem)]",
  "6": "w-[calc(100%+3rem)]",
  "8": "w-[calc(100%+4rem)]",
}

const VERTICAL_BLEED_SIZE_CLASS: Record<SeparatorBleed, string> = {
  "1": "h-[calc(100%+0.5rem)]",
  "2": "h-[calc(100%+1rem)]",
  "3": "h-[calc(100%+1.5rem)]",
  "4": "h-[calc(100%+2rem)]",
  "6": "h-[calc(100%+3rem)]",
  "8": "h-[calc(100%+4rem)]",
}

function Separator({
  className,
  orientation = "horizontal",
  decorative: _decorative,
  edgeToEdge,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive> & {
  decorative?: boolean
  edgeToEdge?: SeparatorBleed
}) {
  const orientationClasses =
    orientation === "vertical"
      ? edgeToEdge
        ? cn("w-px", VERTICAL_BLEED_SIZE_CLASS[edgeToEdge], VERTICAL_BLEED_CLASS[edgeToEdge])
        : "h-full w-px"
      : edgeToEdge
        ? cn("h-px", HORIZONTAL_BLEED_SIZE_CLASS[edgeToEdge], HORIZONTAL_BLEED_CLASS[edgeToEdge])
        : "h-px w-full"

  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn(
        "bg-border shrink-0",
        orientationClasses,
        className
      )}
      {...props}
    />
  )
}

export { Separator }
